export enum EventType {
  Class = 1,
  Gamification = 2,
  Other = 3,
}

export enum EventStatus {
  Approved = 1,
  Pending = 2,
  Declined = 3,
}

export enum UserType {
  Trainer = 1,
  Client = 2,
}

export enum ChallengeLevel {
  Level1 = 1,
  Level2 = 2,
  Level3 = 3,
}

export enum EventApplyOption {
  ONLY_THIS_EVENT = 1,
  THIS_AND_FUTURE_EVENTS = 2,
}

export enum StudyContentType {
  Assesment,
  FunctionalTest,
  Lesson,
  Exercise,
}

export enum LessonType {
  DIY = 1,
  Supervised = 2,
}
